import { useEffect, useState } from 'react';

/**
 * Returns true if WebGL (any version) is available. Returns null while detecting
 * (server-render / first paint), which callers should treat as "not yet known"
 * — render the fallback branch until truthy.
 */
export function useWebGLSupport(): boolean | null {
  const [supported, setSupported] = useState<boolean | null>(null);

  useEffect(() => {
    if (typeof document === 'undefined') {
      setSupported(false);
      return;
    }
    try {
      const canvas = document.createElement('canvas');
      const ctx =
        canvas.getContext('webgl2') ||
        canvas.getContext('webgl') ||
        (canvas.getContext('experimental-webgl') as WebGLRenderingContext | null);
      setSupported(ctx !== null);
    } catch {
      setSupported(false);
    }
  }, []);

  return supported;
}
